<template>
  <div class="hello">

      <div class="footer" @scroll="getFs" ref="foot">
        <div class="title">
          <span>投票</span>
        </div>
        <div class="line"></div>
        <div class="content">
          <div class="default" v-if="voteList.length <= 0">
            <img v-if="lang == 'cn'" src="../assets/image/wu.png" alt="">
            <img v-else src="../assets/image/wuE.png" alt="">
          </div>
          <div v-else class="voteList" v-for="(item,index) in voteList" :key="index" @click="voteDetail(item.id,item.vote_status.key)">
            <div class="voteImage">
              <img :src="item.cover_pic.display_path" alt="">
            </div>
            <div class="center">
              <div class="voteLeft">
                <div class="voteTtile">
                  <span>{{item.title}}</span>
                </div>
                <div class="voteJian" v-if="item.retitle.length > 30">
                  <span>{{item.retitle.substr(0,30)}}...</span>
                </div>
                <div class="voteJian" v-else>
                  <span>{{item.retitle}}</span>
                </div>
                <div class="createTime" v-if="item.vote_status.key == 1">
                  <span>开始时间(报名)：{{item.vote_status.time}}</span>
                </div>
                <div class="createTime" v-if="item.vote_status.key == 2 || item.vote_status.key == 3">
                  <span>结束时间(报名)：{{item.vote_status.time}}</span>
                </div>
                <div class="createTime" v-if="item.vote_status.key == 4 || item.vote_status.key == 5">
                  <span>结束时间(投票)：{{item.vote_status.time}}</span>
                </div>
              </div>
              <div class="voteRight">
                <div class="titleBtn"  :class="{isc:item.vote_status.key == 5}">
                  <span>{{item.vote_status.value}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="pages">
          <el-pagination v-if="pageShow" background layout="prev, pager, next" :total="total" @current-change="pageEvent">
          </el-pagination>
        </div>
         <div style="height: 200px;"></div>
        <fiex :shows="fixed" :fatherMethod="goTop" ></fiex>
      </div>
      <div class="footerTitle" v-if="footerShow">
         <div class="title_center">
           <div class="listB">
             <span>{{$t('language.address_b')}}：{{address}}</span>
           </div>
           <div class="listB">
             <span>{{$t('language.emails')}}:{{email}}</span>
           </div>
         </div>
       </div>
    </div>
</template>

<script>
  import fiex from '../components/fiex.vue'
  export default {
    components:{
      fiex
    },
    data() {
      return {
         fixed:false,
        imageUrl: require('../assets/image/banner1.png'),
        voteList: [],
        total: 0,
        pageShow: true,
        footerShow:true,
        email:'',
        address:'',
        lang:'cn'
      }
    },
    created() {
      if(localStorage.getItem('languageSet') == 'zh'){
         this.lang = 'en'
      }else{
          this.lang = 'cn'
      }
      this.ajaxFun('1')
      this.$fetch('/index/info').then(res=>{
        this.address = res.data.address;
        this.email = res.data.email;
      })
    },
    mounted(){

    },
    methods: {
      goTop(){
          this.$refs.foot.scrollTop = 0;
      },
      getFs(){
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.foot.scrollTop ||
            window.pageYOffset;
            if(scrollTop > 20){
              this.fixed = true;
            }else{
              this.fixed = false;
            }
            let scrollBottom =
              event.target.scrollHeight -
              event.target.scrollTop -
              event.target.clientHeight;
              if(scrollBottom <=0){
                this.footerShow = true;
              }else{
                this.footerShow = false;
              }
      },
      ajaxFun(pages){
        var data = {
          page: pages,
        }
        this.$fetch('/vote/actList', data).then(res => {
          console.log(res.data.data)
          this.voteList = res.data.data;
          this.total = res.data.total
          if (this.total > 10) {
            this.pageShow = true;
          } else {
            this.pageShow = false;
          }
        })
      },
      voteDetail(id,key) {
        if(key == 2){
           this.$router.push({
             path: '/soliciting',
             query: {
               id: id
             }
           })
        }else{
          localStorage.setItem('key',key)
          this.$router.push({
            path: '/hand',
            name:'hand',
            query: {
              id: id,

            },
          })
        }

      },

      pageEvent(e){
        this.ajaxFun(e)
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/vote.css");
</style>



// WEBPACK FOOTER //
// src/pages/vote.vue